export default function(value) {
  if (!value) {
    return true;
  }
  return /^[a-zA-Z0-9 ]*$/i.test(value);
}
